import { makeActionType, getActionType } from '../util/redux';

export const WorkType = 'musicBgVideo';

export const SELECT_MV = 'selectMv';
export const SET_PLAYING_STATE = 'setPlayingState';
export const SET_PLAYING_CURRENTTIME = 'setPlayingCurrentTime';
export const SET_PLAYER = 'setPlayer';
export const SET_SONG_INFO = 'setSongInfo';
export const SET_VIDEO_INFO = 'setVideoInfo';
export const SET_SEGMENT_AXIS = 'setSegmentAxis';
export const SET_SEGMENT_WH = 'setSemgentWH';
export const SET_VIDEO_TRANSFORM = 'setVideoTransform';
export const SET_SEGMENT_TIME = 'setSegmentTime';
export const SET_ACTION_REVERSE = 'setActionReverse';
export const SET_SEGMENT_WIDTH = 'setSegmentWidth';
export const SET_SEGMENT_SCALE = 'setSegmentScale';

makeActionType(WorkType, [
    SELECT_MV,
    SET_PLAYING_STATE,
    SET_PLAYING_CURRENTTIME,
    SET_SONG_INFO,
    SET_VIDEO_INFO,
    SET_PLAYER,
    SET_SEGMENT_AXIS,
    SET_SEGMENT_WH,
    SET_VIDEO_TRANSFORM,
    SET_SEGMENT_TIME,
    SET_ACTION_REVERSE,
    SET_SEGMENT_WIDTH,
    SET_SEGMENT_SCALE
]);

export const type_SET_PLAYING_STATE = getActionType(
    WorkType,
    SET_PLAYING_STATE
);
export const type_SET_PLAYING_CURRENTTIME = getActionType(
    WorkType,
    SET_PLAYING_CURRENTTIME
);
export const type_SELECT_MV = getActionType(WorkType, SELECT_MV);
export const type_SET_SONG_INFO = getActionType(WorkType, SET_SONG_INFO);
export const type_SET_VIDEO_INFO = getActionType(WorkType, SET_VIDEO_INFO);
export const type_SET_PLAYER = getActionType(WorkType, SET_PLAYER);
export const type_SET_SEGMENT_AXIS = getActionType(WorkType, SET_SEGMENT_AXIS);
export const type_SET_SEGMENT_WH = getActionType(WorkType, SET_SEGMENT_WH);
export const type_SET_VIDEO_TRANSFORM = getActionType(
    WorkType,
    SET_VIDEO_TRANSFORM
);
export const type_SET_SEGMENT_TIME = getActionType(WorkType, SET_SEGMENT_TIME);
export const type_SET_ACTION_REVERSE = getActionType(WorkType, SET_ACTION_REVERSE);
export const type_SET_SEGMENT_WIDTH = getActionType(WorkType, SET_SEGMENT_WIDTH);
export const type_SET_SEGMENT_SCALE = getActionType(WorkType, SET_SEGMENT_SCALE);



// WEBPACK FOOTER //
// ./client/action/musicBgVideo.js